module.exports = __webpack_public_path__ + "media/images/site/hamburguer-85bd719bb53ee9468b3d288aaba5b8ff.png";